export const getCurrentMediaQuery = (): number => {
    return Number(window.getComputedStyle(document.documentElement).getPropertyValue('--current-mq'));
};
